$bog_gamengine_demo_crumb2 $mol_page
	title \Крошки мышью
	key_map *
	tools /
		<= Left_label $mol_labeler
			title \Осталось
			content / <= left_str \
		<= Time_label $mol_labeler
			title \Время
			content / <= time_str \
		<= Pause_switch $mol_check_box
			title \Пауза
			checked? <=> paused? false
	body <= field /
		<= Draw $bog_gamengine_draw
			scene <= Scene
			cam <= Cam
			stat => stat
		<= End $mol_page
			title <= end_title \
			body /
				<= End_hint $mol_view
					sub / <= end_hint \
			foot /
				<= Again $mol_button_major
					title \Ещё раз
					click? <=> restart? null
	foot /
		<= Hero_stat $mol_view
			sub / <= hero_str \
		<= Stat $mol_view
			sub / <= stat
	Clock $bog_gamengine_clock
		paused <= paused false
	Key $bog_gamengine_key
		bind *
			left /
				\A
				\left
			right /
				\D
				\right
			up /
				\W
				\up
			down /
				\S
				\down
	Input $bog_gamengine_input
		key <= Key
	Cam $bog_gamengine_cam_flat
		height 11
		pos <= cam_pos Float32Array
	Scene $bog_gamengine_demo_crumb2_level
		clock <= Clock
		input <= Input
		cam <= Cam
		auto_nodes <= nodes /
	Rule $bog_gamengine_demo_crumb2_rule
		hero <= hero null
		crumbs <= crumbs /
		limit 40
